module.exports = __webpack_public_path__ + "images/80806c28.png";